import { useContext } from 'react';
import { useQuery } from 'react-query';
import { SettingsContext } from '../store/SettingsContext';
import { UserContext } from '../store/UserContext';
import useAxios from './useAxios';
import useSubscriber from './useSubscriber';

export namespace OnlyFansUserT {
    export interface Response {
        view: string;
        id: number;
        name: string;
        username: string;
        isVerified: boolean;
        avatar: string;
        avatarThumbs?: AvatarThumbs;
    }

    export interface AvatarThumbs {
        c50?: string; // Small - 50x50
        c144?: string; // Medium - 144x144
    }
}

const useSubscriberUsernameSearchT = (search: string) => {
    const userContext = useContext(UserContext);
    const settingsContext = useContext(SettingsContext);
    const { data: subscriber } = useSubscriber();
    const axios = useAxios();

    const fetchData = async (): Promise<OnlyFansUserT.Response[]> => {
        const query: string = `${settingsContext.routes.onlyFans.base}${subscriber._id}/users/find/t?${new URLSearchParams({
            query: search,
        })}`;

        return axios
            .get(query)
            .then(response => response.data)
            .catch(() => {
                return [];
            });
    };

    const query = useQuery(['subscriberUsernameSearchT', subscriber?._id, search], () => fetchData(), {
        refetchOnWindowFocus: false,
        staleTime: Infinity,
        refetchInterval: false,
        enabled: userContext.jwtToken && settingsContext.apiKey && subscriber?._id && search ? true : false,
    });

    return { ...query };
};

export default useSubscriberUsernameSearchT;
